import ReadWriteLockExternal from "rwlock";

import { LockHandle } from "./LockHandle";

export class ReadWriteLockCollection {
    private readonly lock: ReadWriteLockExternal;

    public constructor() {
        this.lock = new ReadWriteLockExternal();
    }

    public acquireWrite(key: string): Promise<LockHandle> {
        return new Promise<LockHandle>(resolve => {
            this.lock.writeLock(key, releaseCallback => {
                resolve(new LockHandle(releaseCallback));
            });
        });
    }

    public acquireRead(key: string): Promise<LockHandle> {
        return new Promise<LockHandle>(resolve => {
            this.lock.readLock(key, releaseCallback => {
                resolve(new LockHandle(releaseCallback));
            });
        });
    }
}
